module.exports = __webpack_public_path__ + "img/pokemon-wild-area.3532199f.png";